module.exports = __webpack_public_path__ + "images/2d61f70aa3920488e6913cb113fe0ae0.svg";